import content from '@/store/modules/profile/content';
import stripeData from '@/store/modules/profile/stripeData';
import subscriptionOptions from '@/store/modules/profile/subscriptionOptions';
import goalProgress from '@/store/modules/profile/goal-progress';

export default {
  namespaced: true,
  modules: {
    content,
    stripeData,
    subscriptionOptions,
    goalProgress,
  },
};
